const OldAgeIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={32}
    height={32}
    viewBox='0 0 32 32'
    fill='none'
    {...props}>
    <g
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeWidth={1.02}
      clipPath='url(#time-black_svg__a)'>
      <path d='m9.7 10.408 4.74 4.27M17.807 15.959c0 1.048-.868 1.898-1.939 1.898-1.07 0-1.938-.85-1.938-1.898s.868-1.899 1.938-1.899 1.939.85 1.939 1.899Z' />
      <path d='M26.324 20.2c2.392-5.654-.35-12.136-6.125-14.478-5.774-2.343-12.394.343-14.786 5.997s.35 12.137 6.125 14.479c5.774 2.342 12.394-.343 14.786-5.998ZM8.005 15.957H4.66M23.734 15.957h3.345M15.867 23.66v3.174M15.867 8.256V4.98M17.23 14.676l3.281-3.088' />
      <path d='M15.87 30.52c8.211 0 14.868-6.519 14.868-14.56S24.081 1.4 15.87 1.4 1 7.92 1 15.96s6.657 14.56 14.87 14.56Z' />
    </g>
    <defs>
      <clipPath id='time-black_svg__a'>
        <path fill='#fff' d='M0 0h32v32H0z' />
      </clipPath>
    </defs>
  </svg>
)

export default OldAgeIcon
